import { useContext } from "react";
import { GameContext } from "./GameContext";
import { IGameContextValue } from "./_types";

export function useGameContext(): IGameContextValue {
	return useContext(GameContext);
}
